import { useEffect, useState } from "react";
const ProtectedRouteHook = () => {
  //   const user =
  //   localStorage.getItem("userhr") !== null ? localStorage.getItem("userhr") : null;
  // const Data = JSON.parse(user);
  const [userData, setUserData] = useState(
    JSON.parse(localStorage.getItem("userhr"))
  );
  const [isUser, setIsUser] = useState();
  const [isAdmin, setIsAdmin] = useState();
  const [isSubuser, setIsSubuser] = useState();
  const [isEditor, setIsEditor] = useState();
  const [isEmp, setisEmp] = useState();

  const logout = () => {
    localStorage.removeItem("tokenhr");
    localStorage.removeItem("userhr");

    window.location.href = "/login";
  };
  useEffect(() => {
    if (userData !== null) {
      if (
        userData.roleName === "Responsible" ||
        userData.roleName === "Manger"
      ) {
        setIsUser(true);
        setIsAdmin(false);
        setIsSubuser(false);
        setisEmp(false);

        setIsEditor(false);
      } else if (userData.roleName === "Admin") {
        setIsUser(false);
        setIsAdmin(true);
        setIsSubuser(false);
        setisEmp(false);

        setIsEditor(false);
      } else if (userData.roleName === "Employee") {
        setIsUser(false);
        setIsAdmin(false);
        setIsSubuser(false);
        setisEmp(true);

        // setIsEditor(true);
      } else if (userData.roleName === "SubUser") {
        setIsUser(false);
        setIsAdmin(false);
        setIsSubuser(true);
        setisEmp(false);

        setIsEditor(false);
      } else if (userData.roleName === "emp") {
        setIsUser(false);
        setIsAdmin(false);
        setIsSubuser(false);
        setIsEditor(false);
        setisEmp(true);
      } else {
        setIsAdmin(false);
        setIsUser(false);
        setIsSubuser(false);
        setIsEditor(false);
        setisEmp(false);

        logout();
      }
    } else {
      setIsAdmin(false);
      setIsUser(false);
      setIsSubuser(false);
      setIsEditor(false);
      setisEmp(false);
    }
  }, []);
  return [isUser, isAdmin, userData, isSubuser, isEditor, isEmp];
};

export default ProtectedRouteHook;
